import { DiseaseEncyclopediaFaqModel } from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';

interface Props {
  faqTitle: string;
  faqs: Array<DiseaseEncyclopediaFaqModel>;
}

const DiseaseEncyclopediaFaq = ({ faqTitle, faqs }: Props) => {
  if (!faqs || faqs.length === 0) {
    return <></>;
  }

  return (
    <div className='mb-[40px] flex flex-col gap-4 px-[24px]' id={`${faqTitle}`}>
      <div>
        <h2 className='typography-ui-24sb text-gray-900'>{faqTitle}</h2>
      </div>

      {faqs.map((faq, index) => (
        <div key={index} className='py-[20px]'>
          <div className='mb-[8px] flex items-center gap-[10px]'>
            <div className='flex h-[28px] w-[28px] flex-shrink-0 items-center justify-center rounded-[40px] bg-gray-700'>
              <span className='typography-ui-13m text-white'>Q{index + 1}</span>
            </div>
            <h3 className='typography-ui-19sb text-gray-700'>{faq.getQuestion()}</h3>
          </div>
          <div className='pl-[42px]'>
            <p className='typography-article-18r text-gray-600'>{faq.getAnswer()}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DiseaseEncyclopediaFaq;
